// extracted by mini-css-extract-plugin
export var navigator = "EduNewsSection-module--navigator--4470d";
export var newsHolder = "EduNewsSection-module--newsHolder--8aee4";
export var newsItem = "EduNewsSection-module--newsItem--c3703";
export var newsItemContent = "EduNewsSection-module--newsItemContent--730e4";
export var newsRoll = "EduNewsSection-module--newsRoll--e4399";
export var title = "EduNewsSection-module--title--f793f";
export var titleWrapper = "EduNewsSection-module--titleWrapper--af820";
export var wrapper = "EduNewsSection-module--wrapper--4913f";